import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import iptracker from '../../../../views/components/commonfunction/iptracker';

export default {
  name: 'pushMissingPOD',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    utility,
    vueMultiSelect,
    iptracker,
    Loader
  },
  data: function() {
    return {
	  picked: 1,		
      shipmentId: '',
      awbErr:'',
      msg: 'Maximum 10 AWBs allowed',
      isLoading:false,
      showAWBStatus:false,
      finalresult: [],
      userdetail: {},
      awbarr: [],
	  currentTab: 'First',
    itemList:[],
    invalidAwb:false,
    allInvalidAwb:'',
    awbInvalidErr:''
    }
  },
  computed: {
	currentTabComponent: function () {
	  this.picked=(this.currentTab=='First')?1:2;
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
  },
  methods: {
    async updateMissingPODUrl() {
      try {
        if(this.checkErr()){
          return false
        }
        this.commenterr = ''
        this.awbErr = ''
        this.isLoading = true
        let result =[];
        let temArr =[];
        let inputPayload ={}
       
          inputPayload = {
           "awb" : this.awbarr
          }
          this.isLoading = true
          result = await utility.missingPod(inputPayload);
          
      this.finalresult = result     
      
      result.data.data[0].finalDeliveredawbarr.forEach(item=>{
        this.itemList.push({awb:item.ParentAWB,comment:"Successfully Delivered"})
      })

      result.data.data[0].finalUndeliveredAwbArr.forEach(item=>{
        this.itemList.push({awb:item,comment:"Shipment is not delivered yet"})
      })

      result.data.data[0].legacyawb.forEach(item=>{
        this.itemList.push({awb:item,comment:"Awb is from leagacy"})
      })

      result.data.data[0].invalidawbs.forEach(item=>{
        this.itemList.push({awb:item,comment:"Invalid Awbs"})
      })

      result.data.data[0].trackonArr.forEach(item=>{
        this.itemList.push({awb:item,comment:"Not Applicable(Client is trackon)"})
      })
      
      result.data.data[0].tripNotClosed.forEach(item=>{
        this.itemList.push({awb:item,comment:"Trip not closed! please close the trip for this shipment"})
      })

      result.data.data[0].podAlreadyUpdated.forEach(item=>{
        this.itemList.push({awb:item,comment:"Pod already updated for this shipment"})
      })

      this.getTraceIP(inputPayload)
      this.isLoading = false
        this.showAWBStatus=true;
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmitSearch() {
      try {
      this.updateMissingPODUrl()
      } catch (err) {
        console.log(err);
      }
    },

    validateParentAwbArray(arrParentAwbNo) {
      try {
        let validShipment = []
        let invalidShipment = []
        let message = "";
        let status = true;
        let data = [];
        let regexSurface = new RegExp('^9|^9169')
        let revereseAwb = new RegExp('^R_', "i")
        let regexSurfacetest = new RegExp('^9 | ^9169 | ^7 | 7167 | ^I5 | ^G8 | ^9W | ^UK | ^SG | ^AI | ^LB | ^BZ | ^GE')
        let regexAir = new RegExp("^7|^7167");

        let regexAirAsia = new RegExp("^I5", "i");
        let regexGoAir = new RegExp("^G8", "i");
        let regexJetAirways = new RegExp("^9W", "i");
        let regexVistara = new RegExp("^UK", "i");

        let regexSpiceJet = new RegExp("^SG", "i");
        let regexAirIndia = new RegExp("^AI", "i");
        let regexGoAirCosta = new RegExp("^LB", "i");
        let regexBlueDart = new RegExp("^BZ", "i");
        let regexIndigo = new RegExp("^GE", "i");
        arrParentAwbNo.forEach(element => {
          let shipmentElement = (element)?element.trim():"";
          if (shipmentElement) {
            if (shipmentElement.length >= 9 && shipmentElement.length <= 16) {
              if (regexSurface.test(shipmentElement) || regexAir.test(shipmentElement) || regexAirAsia.test(shipmentElement) || regexGoAir.test(shipmentElement) ||
                regexJetAirways.test(shipmentElement) || regexVistara.test(shipmentElement) || regexSpiceJet.test(shipmentElement) || regexAirIndia.test(shipmentElement)
                || regexGoAirCosta.test(shipmentElement) || revereseAwb.test(shipmentElement) || regexBlueDart.test(shipmentElement) || regexIndigo.test(shipmentElement)) {
                

                validShipment.push(shipmentElement)
              } else {

                invalidShipment.push(shipmentElement)
                status = false;
                message = "AWB Series does not match, AWB series for surface - (9169 OR 9) and Air - (7167 OR 7)";
                data = invalidShipment
              }
            } else {

              invalidShipment.push(shipmentElement)

              status = false;
              message = "Invalid AWB No. (AWB No. must be min 10 or max 16 digit)";
              data = invalidShipment

            }
          } 
        });

        return ({ status: status, valid: validShipment, invalid: invalidShipment, message: message, data: data })

      } catch (error) {
        console.log("Error", error)
      }
    },
    checkErr() {
      this.awbarr = [];
      let err = false
      this.awbarr = (this.shipmentId.split(/[\n,]+/));
      this.awbarr=this.awbarr.filter(value => value !== '');

      if (this.awbarr.length >= 11) {
        err = true
        this.awbErr = 'Maximum 10 AWBs allowed'
      }

      let checkAwb = this.validateParentAwbArray(this.awbarr)
      if (checkAwb.status == false) {
        err = true;
        this.awbInvalidErr = checkAwb.message;
        this.invalidAwb = true;
        this.allInvalidAwb = checkAwb.data.toString();
      }
      return err
    },
	
    closeShowAWBStatus(){
      this.showAWBStatus=false;
      this.finalresult=[],
      this.shipmentId='',
      this.itemList=[]
      this.reset();
    },

    closeModelInvalidShipment(){
      this.invalidAwb=false;
      this.allInvalidAwb=''
      this.awbInvalidErr=''
      
    },
	
    reset() {
      this.shipmentId = '',
      this.awbErr = '',
      this.awbarr = [],
      this.$validator.reset();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.onSubmitSearch(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
	
    getTraceIP(data) {
      try {
        let payload = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/pushMissingPOD',
          "meta" : {
            "event" : `Mark Shipment Invalid`,
            "data" : data
          }
        }
        let result = iptracker.getTraceIP(payload);
      } catch (error) {
        console.log(error)
      }
      
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/pushMissingPOD/pushMissingPOD.component.js